import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import TweenMax from "gsap";
import Power2 from "gsap";
import Power1 from "gsap";
import Power4 from "gsap";
import {Signals} from "@/Imports";
import PlaneConfig from "@/config/PlaneConfig";
import Facade from "@/Facade";
import * as PIXI from "pixi.js";
import Config from "@/config/Config";
import BulletContainer from "./BulletContainer";

export default class PlaneContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init(data)

    this.trackThePath = false

    /*
      gun
      idle
      idle_gun
      kill
      kill_noGun
      start
      start_idle

      shooting
     */
  }

  init(data) {
    this.activeBullets = []
    this.itemsPool = []

    this.bulletsContainer = data.bulletsContainer

    this.justStarted = false

    this.planeXCenter = 110
    this.battlePosition = -80
    this.cashOutOnScreen = 0
    this.cashOuts = []
    this.cashOutPool = []

    this.startSyncMusicTimeout = null
    this.syncTimeouts = []

    this.arr = this.trackThePath ? [] : PlaneConfig.plane

    Signals.startFeature.add(this.onStartFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)

    Signals.forceRoundStart.add(this.reset, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.playerTakeWin.add(this.onPlayerCashOut, this)

    this.cashOutContainer = new PIXI.Container()
    this.addChild(this.cashOutContainer)

    this.container = new PIXI.Container()
    this.addChild(this.container)

    this.plane = new SpineAnimation('hero')
    this.container.addChild(this.plane)

    this.heroShooting = new SpineAnimation('heroShooting')
    this.heroShooting.x = -40
    this.heroShooting.y = -154
    this.container.addChild(this.heroShooting)

    this.cashOutContainer.position.set(this.container.x, this.container.y)

  }

  onStartFeature() {
    this.plane.start(['gun','idle_gun'], [false, true]);

    this.realStartFeatureTimer = setTimeout(() => {
      this._onStartFeature()
    }, Facade.model.randomTime)
  }

  _onStartFeature() {
    TweenMax.to(this.container, 1, {x: this.battlePosition})
    this.shooting()
  }

  onStopFeature() {
    this.heroShooting.stop()
    clearTimeout(this.startSyncMusicTimeout)
    this.syncTimeouts.forEach(t => clearTimeout(t))
    this.syncTimeouts.length = 0

    clearTimeout(this.realStartFeatureTimer)
    clearTimeout(this.shootingTimeout)

    if (this.isShooting && this.isStopped) {
      this.plane.start(['kill'], [false])
    } else if (!this.isShooting && this.isStopped) {
      this.plane.start(['kill_noGun'], [false])
    }

    Facade.soundManager.stop('cannon_3')

    this.isShooting = false
    if (!this.isStopped) {
      this.plane.start(['gunOut', 'idle'], [false, true])
      TweenMax.to(this.container, 1, {x: this.planeXCenter})
    }

    while (this.activeBullets.length > 0) {
      const b = this.activeBullets.pop()
      b.stop()
      this.poolBulletIn(b)
    }

    this.activeBullets.length = 0
  }

  onMakeBets() {
    TweenMax.killTweensOf(this)
    TweenMax.killChildTweensOf(this)
    this.y = Config.currentPattern.planeContainer.y

    this.container.position.set(0, 0)
    this.container.visible = true
    this.plane.visible = true
    this.justStarted = true
    this.plane.start(['start_idle'], [true])

    setTimeout(() => {
      this.container.position.set(0, 0)
    }, 50)
  }

  reset() {
    this.stop()
    TweenMax.killTweensOf(this)
    TweenMax.killChildTweensOf(this)

    this.container.position.set(0, 0)
    this.isPlaneStopped = false

    this.cashOutContainer.position.set(this.container.x, this.container.y)
    this.justStarted = true

    while (this.cashOuts.length > 0) {
      this.poolIn(this.cashOuts.pop())
    }
  }

  start() {
    this.isStopped = false
    this.container.position.set(0, 0)

    if (!this.trackThePath) {
      this.a = Math.round(Facade.model.deltaTime * 60)

      if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
        this.a = this.arr.length - 1
        const o = this.arr[this.arr.length - 1]

        this.container.position.set(o.x, o.y)

        this.plane.start(['idle'], [true])
      } else {
        this.plane.start(['start', 'idle'], [false, true])
      }
    } else {
      this.arr.length = 0

      TweenMax.to(this.container, 1, {
        y: -160, ease: Power4.easeOut, onComplete: () => {
          TweenMax.to(this.container, 3, {
            y: -40, ease: Power1.easeIn, onComplete: () => {
            }
          })
        }
      })

      TweenMax.to(this.container, 4, {
        x: this.planeXCenter, ease: 'none', onComplete: () => {
          this.stop()
        }
      })
    }

    Signals.tick.add(this.update, this)
  }

  stop() {
    this.isPlaneStopped = true

    if (this.trackThePath) {
      console.log('>>> hero path tracking', this.arr)
    }

    Signals.tick.remove(this.update, this)
  }

  update() {
    const {container} = this

    if (this.trackThePath) {
      const a = {
        x: Number(container.x.toFixed(2)),
        y: Number(container.y.toFixed(2)),
      }

      this.arr.push(a)

      return
    }

    const o = this.arr[this.a]
    this.container.x = o.x
    this.container.y = o.y

    this.a++
    if (this.a === this.arr.length) {
      this.a = this.arr.length - 1
      this.stop()
    }
  }

  onRoundEnd() {
    clearTimeout(this.realStartFeatureTimer)

    Facade.soundManager.play('santaEscapeSound')

    this.stop()

    this.isStopped = true
    this.onStopFeature()

    TweenMax.killTweensOf(this)
  }

  onPlayerCashOut(data) {
    let animationName = ''

    Facade.soundManager.play('gameCashoutSound', 0.8)

    // TODO:
    // if (data.i === Facade.model.betId1 || data.i === Facade.model.betId2) {
    //   animations = this.mainPlayerAnimations
    // } else {
    //   animations = this.otherPlayerAnimations
    // }

    animationName = 'animation'

    if (this.cashOutOnScreen >= Config.MAX_CASHOUT_ON_SCREEN) {
      return
    }

    this.cashOutOnScreen++
    const p = this.poolOut()
    p.visible = true
    p.start([animationName], [false])
    p.position.set(-110, -50)

    this.cashOutContainer.position.set(this.container.x, this.container.y - 30)

    TweenMax.to(p, 0.5, {
      x: '-=100', ease: Power2.easeIn, delay: 0.2, onComplete: () => {
        TweenMax.to(p, 2, {
          x: '-=300', onComplete: () => {
            this.cashOutOnScreen--
          }
        })
      }
    })
    this.cashOuts.push(p)
  }

  poolIn(cashOutItem) {
    cashOutItem.stop()
    cashOutItem.visible = false
    this.cashOutPool.push(cashOutItem)
  }

  poolOut() {
    if (this.cashOutPool.length === 0) {
      const p = new SpineAnimation('cashOut')
      p.name = 'CashOutAnimation'
      p.position.set(-110, -50)
      this.cashOutContainer.addChild(p)
      this.cashOutPool.push(p)
    }
    return this.cashOutPool.pop()
  }

  shooting() {
    this.isShooting = true

    const musicOffset = 300

    this.startSyncMusicTimeout = setTimeout(() => Facade.soundManager.play('cannon_3', 0.7, true), musicOffset)
    this.syncShootingWithMusic()
  }

  syncShootingWithMusic() {
    const offset = 0
    this.syncTimeouts = [

    // Jingle bells are here
    setTimeout(() => this.shoot(), offset + 10),
    setTimeout(() => this.shoot(), offset + 357),
    setTimeout(() => this.shoot(), offset + 650),

    setTimeout(() => this.shoot(), offset + 1223),
    setTimeout(() => this.shoot(), offset + 1516),
    setTimeout(() => this.shoot(), offset + 1810),

    setTimeout(() => this.shoot(), offset + 2371),
    setTimeout(() => this.shoot(), offset + 2627),
    setTimeout(() => this.shoot(), offset + 2952),

    setTimeout(() => this.shoot(), offset + 3356),
    setTimeout(() => this.shoot(), offset + 3528),


    setTimeout(() => this.shoot(), offset + 4664),
    setTimeout(() => this.shoot(), offset + 4972),
    setTimeout(() => this.shoot(), offset + 5251),

    setTimeout(() => this.shoot(), offset + 5821),
    setTimeout(() => this.shoot(), offset + 6123),
    setTimeout(() => this.shoot(), offset + 6409),

    setTimeout(() => this.shoot(), offset + 6975),
    setTimeout(() => this.shoot(), offset + 7301),
    setTimeout(() => this.shoot(), offset + 7553),

    setTimeout(() => this.shoot(), offset + 8010),
    setTimeout(() => this.shoot(), offset + 8141),

    // And repeat it again
    setTimeout(() => this.syncShootingWithMusic(), 9299)
    ]
  }

  shoot() {
    if (this.isShooting) {
      this.heroShooting.start(['shooting'], [true])
      const b = this.poolBulletOut()
      this.activeBullets.push(b)
      b.position.set(-100, -180)
      b.start()
    }
  }

  poolBulletIn(item) {
    this.itemsPool.push(item)
    item.visible = false
  }

  poolBulletOut() {
    if (this.itemsPool.length === 0) {
      const p = new BulletContainer(0.5, {x: 456, y: 83})
      this.bulletsContainer.addChild(p)
      this.itemsPool.push(p)
    }

    const p = this.itemsPool.pop()
    p.visible = true
    return p
  }

}
